import { Model } from '@vuex-orm/core'

export default class IntervideoRating extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'intervideoRatings'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      intervideo_id: this.attr(null),
      question_id: this.attr(null),
      comment: this.attr(null),
      rating: this.attr(null),
      author_user_id: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/IntervideoRating.js